import { CoachInfo } from '../store/types';

export const convertCoachesToTable = (coaches: CoachInfo[]) => coaches.map((coach) => ({
  ...coach,
  key: coach.id,
}));
